import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=6b072396&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts&"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=6b072396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b072396",
  null
  
)

export default component.exports